import axios from 'axios';
import { message } from 'antd';
import { getActiveApiBaseUrl } from './apiBaseConfig';

export const apiBaseUrl = getActiveApiBaseUrl();
export { getActiveApiBaseUrl, isLocalApi } from './apiBaseConfig';

const apiClient = axios.create({
  baseURL: apiBaseUrl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    accept: '*/*',
  },
});

let isSessionRedirectInProgress = false;

function handleSessionExpiryOnce(): void {
  if (isSessionRedirectInProgress) return;
  isSessionRedirectInProgress = true;

  localStorage.clear();
  sessionStorage.clear();

  if (window.location.pathname !== '/login') {
    message.error('Session expired. Please login again.');
    // replace avoids adding back-stack entries and reduces redirect flicker
    window.location.replace('/login');
  }
}

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const base = config.baseURL || apiClient.defaults.baseURL || '';
  if (base.includes('ngrok')) {
    config.headers['ngrok-skip-browser-warning'] = 'true';
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 || error?.response?.data?.error === 'Unauthorized') {
      handleSessionExpiryOnce();
    } else if (error.code === 'ERR_NETWORK' && !error.response) {
      message.error('Network error contacting server. Please check your connection.');
    }
    return Promise.reject(error);
  },
);

export default apiClient;
